import { TCreateContactReqDto, TCreateContactResDto } from "@/api/services/main/contact/dtos/create-contact.dto";
import { clientApi } from "@/utils/api";

export const createContactApi = async (payload: TCreateContactReqDto): Promise<TCreateContactResDto> => {
  const rs = await clientApi.post<TCreateContactResDto>("/contacts", payload);
  return rs.data;
};
